export const theme = {
  colors: {
    white: '#FFFFFF',
    black: '#111111',
    blackBg: '#181A1B',
    green: '#31EC56',
    darkGreen: '#1A9B3F',
    gray: '#22272A',
    border: '#23282F',
    lightGray: '#F4F6F8',
  },
  font: {
    main: "'Segoe UI', 'Inter', Arial, sans-serif",
    heading: "'Segoe UI Semibold', 'Inter', Arial, sans-serif",
  },
};
